// Characters that make spreadsheet software interpret a cell as a formula
const FORMULA_TRIGGER = /^[=+\-@\t\r]/;

/**
 * Neutralize user-controlled CSV cell values so they are not executed as formulas when the file is opened
 * in spreadsheet software. Values starting with a formula character are prefixed with an apostrophe.
 */
export function sanitizeCsvCell<T>(value: T): T | string {
  if (typeof value === "string" && FORMULA_TRIGGER.test(value)) {
    return "'" + value;
  }
  return value;
}

/**
 * Format value as a ="..." text formula so spreadsheet software keeps it as text (e.g. leading zeros in IDs and
 * GSM numbers). Double quotes are escaped so the value can't break out of the formula string.
 */
export function csvTextCell(value: string | number | null | undefined): string {
  return `="${String(value ?? "").replace(/"/g, '""')}"`;
}
